function compartilharAgendamento(url, traducoes) {
    if (navigator.share) {
        navigator.share({
            title: traducoes.texto_titulo_compartilhar,
            text: traducoes.confira_detalhes_agendamento,
            url: url
        }).catch((error) => console.log('Erro ao compartilhar:', error));
    } else if (navigator.clipboard) {
        navigator.clipboard.writeText(url)
            .then(() => {
                Swal.fire({
                    icon: 'success',
                    title: traducoes.copiado,
                    text: traducoes.link_copiado_transferencia,
                    confirmButtonText: 'OK',
                    customClass: {
                        title: 'text-lg font-semibold text-gray-700',
                        content: 'text-sm text-gray-600',
                        confirmButton: 'bg-blue-500 text-white font-medium rounded-md px-4 py-2 shadow-sm hover:bg-blue-600',
                    }
                });
            })
            .catch(() => {
                Swal.fire({
                    title: traducoes.copie_este_link + ':',
                    input: 'text',
                    inputValue: url,
                    inputAttributes: {
                        readonly: true
                    },
                    customClass: {
                        input: 'swal2-input-custom',
                        title: 'text-lg font-semibold text-gray-700',
                        confirmButton: 'bg-blue-500 text-white font-medium rounded-md px-4 py-2 shadow-sm hover:bg-blue-600',
                        cancelButton: 'bg-gray-300 text-gray-800 font-medium rounded-md px-4 py-2 shadow-sm hover:bg-gray-400',
                    },
                    showCancelButton: true,
                    confirmButtonText: traducoes.copiar_link,
                    cancelButtonText: traducoes.fechar,
                    didOpen: () => {
                        const input = Swal.getInput();
                        input.style.maxWidth = '100%';
                        input.style.boxSizing = 'border-box';
                        input.style.overflowX = 'auto';
                        input.style.whiteSpace = 'nowrap';
                        input.select();
                    },
                    preConfirm: () => {
                        return navigator.clipboard.writeText(url)
                            .then(() => {
                                Swal.fire({
                                    icon: 'success',
                                    title: traducoes.copiado,
                                    text: traducoes.link_copiado_transferencia,
                                    confirmButtonColor: '#3483FA'
                                });
                            })
                            .catch(() => {
                                Swal.showValidationMessage(traducoes.erro_copiar);
                            });
                    }
                });
            });
    } else {
        Swal.fire({
            title: traducoes.copie_este_link + ':',
            input: 'text',
            inputValue: url,
            inputAttributes: {
                readonly: true
            },
            customClass: {
                input: 'swal2-input-custom',
                title: 'text-lg font-semibold text-gray-700',
                confirmButton: 'bg-blue-500 text-white font-medium rounded-md px-4 py-2 shadow-sm hover:bg-blue-600',
                cancelButton: 'bg-gray-300 text-gray-800 font-medium rounded-md px-4 py-2 shadow-sm hover:bg-gray-400',
            },
            showCancelButton: true,
            confirmButtonText: traducoes.copiar_link,
            cancelButtonText: traducoes.fechar,
            didOpen: () => {
                const input = Swal.getInput();
                input.style.maxWidth = '100%';
                input.style.boxSizing = 'border-box';
                input.style.overflowX = 'auto';
                input.style.whiteSpace = 'nowrap';
                input.select();
            },
            preConfirm: () => {
                return navigator.clipboard.writeText(url)
                    .then(() => {
                        Swal.fire({
                            icon: 'success',
                            title: traducoes.copiado,
                            text: traducoes.link_copiado_transferencia,
                            confirmButtonColor: '#3483FA'
                        });
                    })
                    .catch(() => {
                        Swal.showValidationMessage(traducoes.erro_copiar);
                    });
            }
        });
    }
}

window.compartilharAgendamento = compartilharAgendamento;
